import type { TableView } from "owa-mail-list-store";
import { action } from "satcheljs";
import type { ActionType } from "./userMailInteractionAction";

export interface DELETE_CONVERSATION_STORE_UPDATEActionMessage {
    conversationIds: string[];
    tableView: TableView;
    actionType: ActionType;
}
const defaultExport: (conversationIds: string[], tableView: TableView, actionType: ActionType) => DELETE_CONVERSATION_STORE_UPDATEActionMessage = action("DELETE_CONVERSATION_STORE_UPDATE", (conversationIds: string[], tableView: TableView, actionType: ActionType): DELETE_CONVERSATION_STORE_UPDATEActionMessage => ({
    conversationIds,
    tableView,
    actionType,
}));
export default defaultExport;
